function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_83",
  "data-name": "Group 83",
  transform: "translate(0 11)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M5105.3,426.584h-15.023V409.458a1.663,1.663,0,0,0-1.789-1.5h-30.422a1.664,1.664,0,0,0-1.79,1.5v18.657a1.664,1.664,0,0,0,1.79,1.5h1.648a1.664,1.664,0,0,0,1.79-1.5v-7.75h11.211a1.523,1.523,0,1,0,0-3h-11.211v-6.408h23.546v17.158a1.663,1.663,0,0,0,1.79,1.5h18.46a1.664,1.664,0,0,0,1.79-1.5v-.031A1.664,1.664,0,0,0,5105.3,426.584Z",
  transform: "translate(-5056.279 -412.858)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M5548.875,407.958h-33.294a1.664,1.664,0,0,0-1.789,1.5v18.657a1.664,1.664,0,0,0,1.789,1.5h1.649a1.664,1.664,0,0,0,1.79-1.5V410.989H5534.7v17.126a1.663,1.663,0,0,0,1.789,1.5h1.649a1.664,1.664,0,0,0,1.789-1.5V410.989h8.947a1.664,1.664,0,0,0,1.79-1.5v-.031A1.664,1.664,0,0,0,5548.875,407.958Z",
  transform: "translate(-5459.164 -412.858)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M5513.771,372.043h9.418a1.6,1.6,0,1,0,0-3.157h-9.418a1.6,1.6,0,1,0,0,3.157Z",
  transform: "translate(-5457.226 -379.886)",
  fill: "#fff"
}));

var SvgFlitLogo = function SvgFlitLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91.501,
    height: 27.756,
    viewBox: "0 0 91.501 27.756",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlitLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flit-logo.a10e5fb7.svg";
export { ForwardRef as ReactComponent };